import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import UpgradeIcon from './UpgradeIcon';

import { translate } from 'translations/i18n';

const getFontSize = (size) => {
  if (size === 'small') {
    return '12px';
  } else if (size === 'medium') {
    return '14px';
  } else {
    return '16px';
  }
};

const getMode = (mode) => {
  if (mode === 'dark') {
    return '#ffffff';
  } else return 'var(--cc_color_text_default)';
};

const BadgeContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Label = styled.span`
  display: flex;
  font-weight: 700;
  letter-spacing: 1px;
  color: ${(props) => getMode(props.mode)};
  font-size: ${(props) => getFontSize(props.size)};
  font-family: sans-serif;
  margin-left: 8px;
  text-transform: uppercase;
`;

const UpgradeBadge = ({ style, size, mode, className }) => {
  return (
    <BadgeContainer style={style} className={className}>
      <UpgradeIcon />
      <Label mode={mode} size={size}>
        {translate('upgradeBadge.label')}
      </Label>
    </BadgeContainer>
  );
};

UpgradeBadge.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  style: PropTypes.object,
  mode: PropTypes.oneOf(['light', 'dark']),
  className: PropTypes.string,
};
UpgradeBadge.defaultProps = {
  size: 'medium',
  style: undefined,
  mode: 'light',
};

export default UpgradeBadge;
